<template>
  <div>
  <a ref="lienDownload"></a>
  <liste-template>
    <template #header>
      <h1 class="title is-size-3">{{ $t('listeOtImpression.title') }}</h1>
      <breadcrumb :breadcrumb="breadcrumb"/>
    </template>
    <template #action>
    </template>
    <template #bar-left>
      <div class="column is-narrow">
        <selecteur-action :options="actions" @handleAction="handleAction"
          :placeholder='$t("general.placeHolder.groupedAction")'
          :titleButton="'general.button.apply'"
          :elementsSelectionnes="hasASelection"></selecteur-action>
      </div>
      <form @submit.prevent="recherche()"
        class="column is-narrow  pdr-0">
        <b-input :placeholder="$t('general.button.search')"
          type="search"
          icon="magnify"
          v-model="critereRecherche.auto">
        </b-input>
      </form>
      <div class='column is-narrow'>
        <button class="button" @click='setShowFiltre'>
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">
            {{$t('general.button.filtre')}}
            <label class="has-text-weight-bold"
              :class="nombreCritere > 0 ? '' : 'is-invisible'">
              ({{ nombreCritere }})
            </label>
          </span>
        </button>
        <span @click="reinitialiserFiltre()"
          class="info-circle-right is-pulled-right is-cursor-pointer">
          <b-icon icon="close-circle" type="is-danger"></b-icon>
        </span>
      </div>
    </template>
    <template #bar-right>
      <b-field class="column mg-0">
        <b-checkbox-button
          v-model="withoutImage"
          type="is-primary"
          outlined
          @input="recherche">
          <b-icon
            :icon="withoutImage ? 'image-off-outline' : 'image-outline'"
            class="mg-0">
          </b-icon>
        </b-checkbox-button>
      </b-field>
      <parametrage-table
        :reference-table="constantes.REFERENCE_TABLE_OT_IMPRESSION"
        @endLoadParamtre="startArrayRendering = true">
      </parametrage-table>
    </template>
    <template #content>
      <div v-if="otImpressionRegroupement.length > 0">
        <resume-demande-impression ref="resumeDemandeImpressionRef"
          @changeEtat="changeEtat">
        </resume-demande-impression>
      </div>
      <v-server-table
        url=""
        v-if="startArrayRendering"
        :columns="columns"
        :options="options"
        class="tableWithChildRow"
        :ref="constantes.REFERENCE_TABLE_OT_IMPRESSION"
        @loaded="finLoading" @loading="debutLoading">
        <div slot="selected" slot-scope="props">
          <b-checkbox v-model="props.row.selected" class="has-text-centered"
                      @input="selectionOtImpression(props.row)">
          </b-checkbox>
        </div>
        <template slot='afterTable'>
          <table-items-in-view
            :perPage="resultPerPage"
            @input="$refs[constantes.REFERENCE_TABLE_OT_IMPRESSION].setLimit($event)"/>
        </template>
        <template #enseigne = "{ row }">
          <div>
            {{ row.enseigneNomCommercial }}
          </div>
          <div class="mgt-10px">
            <tag-list
              v-if="getTags(row).length > 0"
              :listes="getTags(row)"/>
          </div>
        </template>
        <template #campagne = "{ row }">
          {{ row.campagneLibelle }}
        </template>
        <template #typeMateriel = "{ row }">
          <b-icon
            v-if="row.materielTypeId && getCouleurInformation(row.materielTypeId)"
            :custom-class="getCouleurInformation(row.materielTypeId).type"
            :class="{ 'demandeImpressionwhiteColorBorder' :
            getCouleurInformation(row.materielTypeId).key === constantes.COULEUR_BLANC}"
            icon="checkbox-blank-circle"
            size="is-small"/>
          {{ row.materielTypeLibelle }}
        </template>
        <template #qteAImprimer = "{ row }">
          <div class="is-pulled-right">
          {{ row.qteAImprimer }}
          </div>
        </template>
        <template #etats = "{ row }" >
          {{ getEtatsLibelles(row.etats) }}
        </template>
        <template #graphisteEnCharge = "{ row }" >
          {{ getGraphistesEnChargeNom(row.graphistesEnCharge) }}
        </template>
        <template #technicienEnCharge = "{ row }">
          <qd-button
            v-if="!row.techniciensEnCharge.length"
            @click="applyUpdateFournisseurTech(row)"
            :class="[
              { 'button-access-no-permission': !checkPermissions(constantes.ORDRE_TRAVAIL.maj) },
            ]"
            class="button is-primary">
            {{ $t('listeOtImpression.actions.prisEnCharge')}}
          </qd-button>
          <span v-else> {{ getTechniciensEnCharge(row.techniciensEnCharge) }} </span>
        </template>
        <template #image = "{ row }">
          <div class="has-text-centered">
            <image-view v-if="row.campagneId"
              :permission="constantes.CAMPAGNE"
              :image="row.cheminMin"
              :id="row.campagneId"
              :libelle="row.campagneLibelle || ' '"
              :maxSize="true"
            />
          </div>
        </template>
        <template v-slot:child_row="{ row }">
          <tab-OtImpression
            class="overflow-x-auto"
            :data="row"
            @prisEnCharge="openPopUpPrevention($event)">
          </tab-OtImpression>
        </template>
      </v-server-table>
    </template>
    <template #after-content>
    </template>
    <template #filter>
      <div class="componentBrief" v-show="showFiltre">
        <filtre-liste-ot-impression  ref="filtreListeOtImpression"
          @toggleFiltre="setShowFiltre"
          @recherche="makeRechercheFilter"/>
      </div>
    </template>
  </liste-template>
  <b-modal v-model="popUpEdition" has-modal-card class="modal">
      <pop-up-edition
        :error="errorEdition"
        :choiceEdition=[]
        @editionChoose="editionOrdreTravail">
      </pop-up-edition>
  </b-modal>
  <b-modal v-model="popUpUpdateEtat" has-modal-card class="modal">
    <pop-up-changer-etat
      :ordreTravail="{}"
      :etatAchanger="etatAchanger"
      :messageHeader="messageHeader"
      :ot-ids-from-action-groupe="otsSelectedIds"
      @close="popUpUpdateEtat = false"
      @update="refreshPage">
    </pop-up-changer-etat>
  </b-modal>
  <b-modal v-model="popUpSelectTechnicien" has-modal-card class="modal">
    <pop-up-technicien-select
    :messHeader="messHeader"
    :otIds="otIds"
    :cancelButtonText="$t('general.non')"
    :validateButtonText="$t('general.oui')"
    @cancel="popUpSelectTechnicien = false"
    @done="recherche"/>
  </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import uniq from 'lodash/uniq';
import cloneDeep from 'lodash/cloneDeep';
import listeTemplate from '@/components/general/template/listeTemplate';
import breadcrumb from '@/components/general/breadcrumb';
import { ORDRE_TRAVAIL_IMPRESSION, ORDRE_TRAVAIL } from '@/configuration/logistique/permissionsLogistiqueConf';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { SET_OT_SELECT } from '@/store/modules/logistique/ordreTravailImpression-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import {
  TEXTS, SORT_ICON, NO_PER_PAGE_VALUE, RESULTS_PER_PAGE,
} from '@/configuration/clientTableConf';
import TableItemsInView from '@/components/general/TableItemsInView';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import messageErreur from '@/services/general/messageErreur';
import filtreListeOtImpression from '@/components/logistique/ordreTravail/impression/filtreListeOtImpression';
import tabOtImpression from '@/components/logistique/ordreTravail/impression/tabOtImpression';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_OT_IMPRESSION } from '@/configuration/general/referenceTableConf';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import formatIsoDate from '@/services/general/formatIsoDate';
import {
  ACTION_MASS_A_EXPEDIER,
  ACTION_MASS_EXPEDITION,
  ACTION_MASS_REALISE,
  ETAT_A_EXPEDIER,
  ETAT_REALISE,
  TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_IMPRESSION,
  LIST_ETAT_OT_TECH,
  ACTION_MASS_PRENDRE_EN_CHARGE,
} from '@/configuration/logistique/ordreTravail/ordreTravailConf';
import selecteurAction from '@/components/general/selecteurAction';
import popUpEdition from '@/components/factures/p_edition';
import edition from '@/api/edition/index';
import resumeDemandeImpression from '@/components/logistique/demandeImpression/resumeDemandeImpression';
import popUpChangerEtat from '@/components/logistique/ordreTravail/tech/popUpChangerEtat';
import tagList from '@/components/general/tagList';
import { columnsSplice } from '@/services/general/columns';
import { CAMPAGNE } from '@/configuration/permissionsBodacConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import nomPrenomGetter from '@/services/general/nomPrenomGetter';
import imageView from '@/components/general/imageView';
import { COULEUR_IMPRESSION, COULEUR_BLANC } from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import popUpTechnicienSelect from '@/components/logistique/ordreTravail/impression/popUpTechnicienSelect';
import validationImpressionEdition from '@/services/logistique/demandeImpression/validationRetourEdition';
import readErrorBlobRequest from '@/services/edition/readBlobRequest';

const Societe = createNamespacedHelpers('societe');
const OrdreTravailImpression = createNamespacedHelpers('ordreTravailImpression');
const Permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const User = createNamespacedHelpers('user');

export default {
  data() {
    return {
      permOtImpression: ORDRE_TRAVAIL_IMPRESSION,
      constantes: {
        REFERENCE_TABLE_OT_IMPRESSION,
        CAMPAGNE,
        COULEUR_BLANC,
        ORDRE_TRAVAIL,
      },
      unsubscribeValue: null,
      showFiltre: false,
      resultPerPage: RESULTS_PER_PAGE,
      startArrayRendering: false,
      selectAllValue: false,
      popUpEdition: false,
      popUpUpdateEtat: false,
      messageHeader: '',
      etatAchanger: null,
      withoutImage: true,
      messHeader: '',
      messagesErreurPopUp: [],
      errorPopUp: false,
      otIds: [],
      popUpSelectTechnicien: false,
      errorEdition: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  components: {
    listeTemplate,
    breadcrumb,
    TableItemsInView,
    parametrageTable,
    filtreListeOtImpression,
    selecteurAction,
    popUpEdition,
    resumeDemandeImpression,
    popUpChangerEtat,
    imageView,
    tagList,
    tabOtImpression,
    popUpTechnicienSelect,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    ...OrdreTravailImpression.mapGetters({
      otImpressionRegroupement: 'items',
      totalCount: 'totalCount',
      critereRecherche: 'criteresRecherche',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeOtImpression.title'), route: '', isActive: true },
      ];
    },
    nombreCritere() {
      const banCritereKey = ['auto', 'dates'];
      let nbCritere = calculNombreCritere(this.critereRecherche, banCritereKey);
      if (this.critereRecherche.dates
        && (this.critereRecherche.dates.dateDebut || this.critereRecherche.dates.dateFin)) {
        nbCritere += 1;
      }
      return nbCritere <= 9 ? nbCritere : '+9';
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          enseigne: this.$t('listeOtImpression.tabs.enseigne'),
          campagne: this.$t('listeOtImpression.tabs.campagne'),
          typeMateriel: this.$t('listeOtImpression.tabs.typeMateriel'),
          qteAImprimer: this.$t('listeOtImpression.tabs.qteAImprimer'),
          image: this.$t('listeOtImpression.tabs.visuelCampagne'),
          etats: this.$t('listeOtImpression.tabs.etats'),
          graphisteEnCharge: this.$t('listeOtImpression.tabs.graphisteEnCharge'),
          technicienEnCharge: this.$t('listeOtImpression.tabs.technicienEnCharge'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        columnsClasses: {
          selected: 'colonneSelected',
          etats: 'colonneWidth250px',
          graphisteEnCharge: 'colonneWidth250px',
        },
        requestFunction: ((data) => {
          data.withoutImage = this.withoutImage;
          data.query = cloneDeep(this.critereRecherche);
          data.query.lieuDelivraisonIds = tagInputToArray(this.critereRecherche.lieuDelivraisonIds, 'id');
          data.query.clientIds = tagInputToArray(this.critereRecherche.clientIds, 'id');
          data.query.dispositifIds = tagInputToArray(this.critereRecherche.dispositifIds, 'id');
          data.query.OtTypeIds = tagInputToArray(this.critereRecherche.OtTypeIds, 'id');
          data.query.campagneIds = tagInputToArray(this.critereRecherche.campagneIds, 'id');
          data.query.enseigneIds = tagInputToArray(this.critereRecherche.enseigneIds, 'id');
          data.query.dates.dateDebut = formatIsoDate(
            data.query.dates.dateDebut,
          );
          data.query.dates.dateFin = formatIsoDate(data.query.dates.dateFin);
          data.query.societeId = this.societeActiveId;
          return this.actionLoadOtImpressions(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.otImpressionRegroupement,
            count: this.totalCount,
          };
        }),
        sortable: ['enseigne', 'campagne', 'typeMateriel'],
      };
    },
    columns() {
      const allColumns = ['selected', 'enseigne', 'campagne', 'etats', 'typeMateriel', 'graphisteEnCharge', 'technicienEnCharge', 'qteAImprimer', 'image'];
      if (this.withoutImage) columnsSplice(allColumns, 'image');
      return allColumns;
    },
    hasASelection() {
      return this.otImpressionRegroupement
        .some(otImpressionRegroupement => otImpressionRegroupement
          .otImpressions.some(otImp => otImp.selected));
    },
    iconSelectTotal() {
      if (this.otImpressionRegroupement.every(item => item
        .otImpressions.every(ot => ot.selected))) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
    actions() {
      const actions = [
        {
          action: ACTION_MASS_A_EXPEDIER,
          translation: 'listeOtImpression.actions.etatAExpedier',
        },
        {
          action: ACTION_MASS_EXPEDITION,
          translation: 'listeOtImpression.actions.editionMasse',
        },
        {
          action: ACTION_MASS_PRENDRE_EN_CHARGE,
          translation: 'listeOtImpression.actions.prisEnCharge',
        },
        {
          action: ACTION_MASS_REALISE,
          translation: 'listeOtImpression.actions.etatRealise',
        },
      ];
      return actions;
    },
    otsSelectedIds() {
      const otsIds = [];
      this.otImpressionRegroupement.forEach(otR => {
        const ids = otR.otImpressions.filter(ot => ot.selected).map(ot => ot.id);
        otsIds.push(...ids);
      });
      return otsIds;
    },
    materielTypes() {
      return this.parametre(PARAMETRES_KEYS.materielType);
    },
  },
  methods: {
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...OrdreTravailImpression.mapActions({
      actionLoadOtImpressions: 'loadOtImpressions',
    }),
    ...OrdreTravailImpression.mapMutations({
      setOtSelect: SET_OT_SELECT,
    }),
    ...Permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
      loadParametres: 'loadParametres',
    }),
    getEtatsLibelles(etats) {
      return etats.map(etatString => {
        const etatFind = LIST_ETAT_OT_TECH.find((etat) => {
          return etat.code === etatString;
        });
        return etatFind ? this.$t(etatFind.libelle) : null;
      })
        .join(', ');
    },
    getUser(userId) {
      const userFound = this.parametre(PARAMETRES_KEYS.utilisateur)
        .find((user) => { return user.id === userId; });
      if (!userFound) return '';
      return nomPrenomGetter(userFound);
    },
    getGraphistesEnChargeNom(graphistes) {
      return graphistes.join(', ');
    },
    getTechniciensEnCharge(techniciens) {
      return techniciens.join(', ');
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    changeEtat(etat) {
      this.critereRecherche.etats = [etat];
      this.recherche();
    },
    recherche() {
      this.$refs[this.constantes.REFERENCE_TABLE_OT_IMPRESSION].refresh();
      this.$refs.resumeDemandeImpressionRef.refresh();
    },
    refreshPage() {
      this.popUpUpdateEtat = false;
      this.recherche();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    goFirstPage() {
      this.$refs[this.constantes.REFERENCE_TABLE_OT_IMPRESSION].setPage(1);
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeOtImpression.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    reinitialiserFiltre() {
      this.$refs.filtreListeOtImpression.initializeFiltre();
      this.$refs.filtreListeOtImpression.viderCritere();
      this.$refs.filtreListeOtImpression.appliquerCritere();
      this.showFiltre = false;
    },
    handleAction(action) {
      switch (action) {
        case ACTION_MASS_EXPEDITION:
          this.applyMassOtImpression();
          break;
        case ACTION_MASS_A_EXPEDIER:
          this.applyMassUpdateEtat(ETAT_A_EXPEDIER);
          break;
        case ACTION_MASS_REALISE:
          this.applyMassUpdateEtat(ETAT_REALISE);
          break;
        case ACTION_MASS_PRENDRE_EN_CHARGE:
          this.openPopUpPrevention();
          break;
        default:
          break;
      }
    },
    applyMassOtImpression() {
      if (this.checkPermissions(ORDRE_TRAVAIL_IMPRESSION.editer)) {
        this.popUpEdition = true;
      } else this.showPopUp();
    },
    getMessageHeader(etat) {
      switch (etat) {
        case ETAT_A_EXPEDIER:
          return this.$t('listeOtImpression.popup.msgAExpedierOt');
        case ETAT_REALISE:
          return this.$t('listeOtImpression.popup.msgRealiseOt');
        default:
          return '';
      }
    },
    applyMassUpdateEtat(etat) {
      this.etatAchanger = etat;
      this.messageHeader = this.getMessageHeader(etat);
      this.popUpUpdateEtat = true;
    },
    selectionOtImpression(row) {
      this.setOtSelect({ lieuLivraisonId: row.id });
    },
    selectAll() {
      this.selectAllValue = !this.selectAllValue;
      this.otImpressionRegroupement.forEach((el) => {
        el.selected = this.selectAllValue;
        this.setOtSelect({ lieuLivraisonId: el.id });
      });
    },
    async editionOrdreTravail(format) {
      this.errorEdition.champsVide = [];
      this.errorEdition.messagesChampsVide = [];
      this.errorEdition.messages = [];
      this.errorEdition.haveError = false;
      const otsIds = [];
      this.otImpressionRegroupement.forEach(oim => {
        const ids = oim.otImpressions.filter(ot => ot.selected).map(ot => ot.id);
        otsIds.push(...ids);
      });
      const loadingComponent = this.$buefy.loading.open();
      try {
        const response = await edition({
          ids: otsIds,
          extension: format,
          typeDonnee: TYPE_EDITION_ORDRE_TRAVAIL_TECHNIQUE_IMPRESSION,
        });
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
        this.popUpEdition = false;
      } catch (e) {
        if (e.response) {
          const errorResponseString = await readErrorBlobRequest(e.response.data);
          const response = JSON.parse(errorResponseString);
          validationImpressionEdition(response, this.errorEdition.messages);
          this.errorEdition.haveError = true;
        } else {
          messageErreur(this.$i18n);
        }
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
    getCouleurInformation(materielTypeId) {
      const couleur = this.materielTypes.find(mat => mat.id === materielTypeId)?.couleur;
      return COULEUR_IMPRESSION.find(
        (couleurImpression) => couleurImpression.key === couleur,
      );
    },
    getTags(row) {
      const tagIds = uniq(row.otImpressions.flatMap((ot) => ot.otTagIds));
      return this.parametre(PARAMETRES_KEYS.tag).filter((tag) => tagIds.includes(tag.id));
    },
    applyUpdateFournisseurTech(row) {
      if (!this.checkPermissions(ORDRE_TRAVAIL.maj)) {
        this.showPopUp();
        return;
      }
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
      this.otIds = row.otImpressions.map(ot => ot.id);
      this.messHeader = this.$t('listeOtImpression.popUpPriseEnCharge.' + (this.otIds.length > 1 ? 'title' : 'titleSingle'));
      this.popUpSelectTechnicien = true;
    },
    openPopUpPrevention(id) {
      if (!this.checkPermissions(ORDRE_TRAVAIL.maj)) {
        this.showPopUp();
        return;
      }
      this.messagesErreurPopUp = [];
      this.errorPopUp = false;
      this.otIds = id ? [id] : this.otsSelectedIds;
      this.messHeader = this.$t('listeOtImpression.popUpPriseEnCharge.' + (this.otIds.length > 1 ? 'title' : 'titleSingle'));
      this.popUpSelectTechnicien = true;
    },
  },
  beforeDestroy() {
    this.unsubscribeValue();
    if (this.lockMenu) this.setLockMenu(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametreUtilisateur();
      await this.loadParametres([PARAMETRES_KEYS.materielType, PARAMETRES_KEYS.tag]);
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageLogistique.ot.listeImpression'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style>

</style>
